import React from 'react'
import { Logo2 } from '../../components/SvgIcons'
import { DEFAULT_ERR_MSG, ERR_MSG_404 } from '../../constants/msgText'

export default function ErrorWidget({ statusCode = 500, errorMessage = DEFAULT_ERR_MSG }) {
  return (
    <div className="error-widget">
      <img src={Logo2} style={{ width: '40%', maxWidth: '250px', height: 'auto' }}></img>
      <div className="error-widget_content">
        <span className="error-widget_text">
          {statusCode == 404 && !errorMessage ? ERR_MSG_404 : errorMessage}
        </span>
        {/* <span className="error-widget__face">:(</span> */}
      </div>
      <div className="error-widget_content">
        <span className="error-widget_code">Error Code : {statusCode}</span>
      </div>
    </div>
  )
}
